import { FORM } from "../../Constants/Endpoints";
import { ApiRequestInterceptor } from "../apiRequest";

export const fetchCreateForm = async (body) => {
  const method = "POST";
  const response = await ApiRequestInterceptor(FORM.form, method, body);

  if (response.code === 201) {
    return response; // aquí normalmente viene { message, FormId, createdAt }
  } else {
    const errorMessage = response?.data?.error || "Error desconocido";
    throw new Error(errorMessage);
  }
};